import { useEffect } from "react";

const UseInterval = (callback, delay) => {
  useEffect(() => {
    if (delay !== null) {
      const interval = setInterval(() => callback(), delay || 0);
      return () => clearInterval(interval);
    }
  }, [callback, delay]);
};

export default UseInterval;
